import { BookingCancellationType } from 'app/constants/enums/BookingCancellationType';
import { CancellationReason } from 'app/constants/enums/CancellationReason';
import { LessonBooking } from 'app/constants/schemas';

export enum LessonBookingOutcomeType {
  Ended,
  Cancelled,
}

interface ILessonBookingOutcome {
  readonly time: Date | null;
  readonly type: LessonBookingOutcomeType;
}

interface ILessonBookingEnded extends ILessonBookingOutcome {
  readonly time: Date;
  readonly type: LessonBookingOutcomeType.Ended;
}

interface ILessonBookingCancelled extends ILessonBookingOutcome {
  readonly cancellationReason: CancellationReason | null;
  readonly cancellationType: BookingCancellationType;
  readonly type: LessonBookingOutcomeType.Cancelled;
}

/**
 * Describes the outcome of a lesson booking.
 */
export type LessonBookingOutcome = ILessonBookingCancelled | ILessonBookingEnded;

export const createLessonBookingOutcome = (lessonBooking: LessonBooking): LessonBookingOutcome | null => {
  if (lessonBooking.cancellation !== null) {
    return {
      cancellationReason: lessonBooking.cancellationReason,
      cancellationType: lessonBooking.cancellation,
      time: lessonBooking.cancellationTime,
      type: LessonBookingOutcomeType.Cancelled,
    };
  }

  if (lessonBooking.endTime !== null) {
    return { time: lessonBooking.endTime, type: LessonBookingOutcomeType.Ended };
  }

  return null;
};
